import './ExamResultParent.scss'
import BranchIcon from '../../assets/icons/BranchIcon.svg'
import TimeTable from '../../assets/icons/TimeTable.svg'
import ResultUser from '../../assets/icons/result-user.svg'
import { ROUTES_PATH } from '../../utility/constants';
import BreadCrumbs from '../breadcrumb/Breadcrumb';
import { useSelector } from 'react-redux';
import { convertDateFormat } from '../../utility/genricFunction';


function ExamResultParent() {
  const { user } = useSelector((state) => state.auth) || {}
  const {result}  = useSelector((state) => state.result)

  const roleName = user?.result?.userData?.roleName

  const miniDivData = [
    { icon: BranchIcon, text: `${result?.length && result[0]?.timetableDetails?.areaName}, ${result?.length && result[0]?.timetableDetails?.cityName}` },
    { icon: TimeTable, text: `${result?.length && convertDateFormat(result[0]?.timetableDetails?.date)} at ${result?.length && result[0]?.timetableDetails?.startTime} to ${result?.length && result[0]?.timetableDetails?.endTime}` },
    { icon: ResultUser, text: `${result?.length && result[0]?.timetableDetails?.facultyName}` }
  ];

  const breadCrumbsArr = [
    {
      title: 'Exam Result',
      link: null,
    },
    {
      title: 'Dashboard',
      link: roleName && roleName == 'faculty' ? ROUTES_PATH.FACULTY_DASHBOARD: ROUTES_PATH.DASHBOARD,
    },
    {
      title: 'Exam Assessment',
      link: roleName && roleName == 'faculty' ? ROUTES_PATH.FACULTY_EXAM_ASSESSMENT: ROUTES_PATH.EXAM_ASSESSMENT,
    },
    {
      title: 'Exam Result',
      link: ROUTES_PATH.EXAM_RESULT_PARENT,
    },
  ]

  return (
    <>
    <div className='exam-result-main'>
      <div>
        <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
      </div>
    </div>
    <div className='exam-result-main-div'>
        <div className='module-accounting-exam-div'>
          <div>
            <div className='module-accounting-exam-div-child'>
              <div className='mcq-div'>
                <p className='mcq'>{result?.length && JSON.parse(result[0]?.timetableDetails?.courseExamFormat.toUpperCase())}</p>
              </div>
              <span className='module-accounting-exam-div-batch'>Batch: {result?.length && result[0]?.timetableDetails?.batchNo}</span>
            </div>
            <div className='module-accounting-exam-div-child-subdiv'>
              <p>{result?.length && result[0]?.timetableDetails?.moduleName}</p>
              <span>Course: {result?.length && result[0]?.timetableDetails?.courseName}</span>
              <div className='mini-div'>
                {miniDivData.map((item, index) => (
                  <span key={index} className='mini-div-flex'>
                    <img src={item.icon} alt='' />
                    <p className='mini-div-font'>{item.text}</p>
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className='total-marks-div'>
            <p>Total Marks: {result?.length && result[0].timetableDetails?.totalMark ? result[0].timetableDetails?.totalMark : 0}</p>
          </div>
        </div>
      </div>
      </>
  )
}

export default ExamResultParent
